// Shared helpers for built-in customer fields (phone, etc.) on internal booking forms.
// Group-level toggles come from localStorage.group (set at login, kept in sync by
// the Booking slot settings drawer on save). Pass the stored group object directly.

export function isInternalPhoneRequired(group) {
  if (!group) return false
  const flag = group.require_phone_internally
  return flag === 1 || flag === '1' || flag === true
}

// Accepts either the composite `user` object used across booking forms
// (phone + optional phoneE164) or a plain string. Returns true if the
// phone is considered present.
function hasPhoneValue(userOrPhone) {
  if (userOrPhone == null) return false
  if (typeof userOrPhone === 'string') return userOrPhone.trim().length > 0
  const e164 = userOrPhone.phoneE164
  const phone = userOrPhone.phone
  if (e164 && String(e164).trim()) return true
  if (phone && String(phone).trim()) return true
  return false
}

// Returns true when the phone requirement is satisfied (either not required
// or present). Forms should block submission when this returns false.
export function validateInternalCustomerPhone(user, group) {
  if (!isInternalPhoneRequired(group)) return true
  return hasPhoneValue(user)
}
